import {
  TbCircle,
  TbCircleHalf2,
  TbCircleCheckFilled,
  TbCircleDashed
} from "react-icons/tb";
import { RiEye2Line } from "react-icons/ri";

/**
 * Maps icon name strings to their corresponding React icon components
 * @param {string} iconName - The name of the icon to retrieve
 * @returns {React.ComponentType} The icon component
 */
export function getIconComponent(iconName) {
  const iconMap = {
    'circle-dashed': TbCircleDashed,
    'circle': TbCircle,
    'circle-half': TbCircleHalf2,
    'circle-eye': RiEye2Line,
    'circle-check': TbCircleCheckFilled
  };
  return iconMap[iconName];
} 